import {
  getFontScale,
  getScaledSize,
  getScaledSpacing,
} from '../../themes/theme';

export const useFontScale = () => {
  const fontScale = getFontScale();

  return {
    fontScale,
    getScaledSize,
    getScaledSpacing,
  };
};
